<template>
  <div class="wrapper" style="max-width:400px;">
    <button @click="saveLogin" class="btn btn-primary"><font-awesome-icon icon="save"/>&nbsp;Speichern</button><br/><br/>
    <div class="form-group">
      <label>Login:</label>
      <input class="form-control" type="text" v-model="login"/>
    </div>
    <div class="form-group">
      <label>Passwort:</label><br/>
      <input class="form-control" type="password" v-model="pass"/><br/>
    </div>
    <div class="form-group">
      <label>Wiederholung:</label><br/>
      <input class="form-control" type="password" v-model="repeat"/><br/>
    </div>
  </div>
</template>

<script>
import ihanduser from '@/modules/ihanduser.js'

export default {
  name: 'iHandUserLogin',
  props: ['loginid','userid'],
  data() {
    return {
      login: '',
      pass: '',
      repeat: '',
    }
  },
  watch: {
    // TODO make it better
    loginid: function(data) {
      console.log('id update: ' + data + '/' + this.loginid);
      this.login = this.loginid;
    }
  },
  methods: {
    saveLogin: function() {
      if (this.pass == '') {
        this.$bvToast.toast('Leeres Passwort nicht erlaubt.',{title: 'iHand Login',variant:'warning'});
        return;
      }
      if (this.pass != this.repeat) {
        this.$bvToast.toast('Passwortwiederholung stimmt nicht überein.',{title: 'iHand Login',variant:'warning'});
        return;
      }
      var self = this;
      console.log(this.login);
      var login = {uid: this.userid,login: this.login, pass: this.pass };
      ihanduser.savelogin(this,login,function() {
        self.$bvToast.toast('Login gespeichert.',{title: 'iHand Login',variant: 'success'});
      });
    }
  }
}
</script>
